import { createAction } from 'redux-actions';
export const BaseStateFieldKey = {
    CURRENT_PAGE: 'curPage',
    SELECTED_MATERIAL: 'selectedMaterial',
    MATERIAL_CONFIG_LIST: 'materialConfigList',
    USER_ORIGIN_IMAGE: 'userOriginImage',
    USER_CROPPED_IMAGE: 'userCroppedImage',
    IMAGE_RESULT_URL: 'imageResultUrl',
    IMAGE_RESULT_URL_LIST: 'imageResultUrlList',
    VIDEO_RESULT_URL: 'videoResultUrl',
    VIDEO_RESULT_URL_WITH_QR_CODE: 'videoResultUrlWithQrCode',
    VIDEO_RESULT_POSTER_URL: 'videoResultPosterUrl',
    VIDEO_RESULT_DOWNLOAD_IMAGE_URL: 'videoResultDownloadImageUrl',
    IS_VIDEO: 'isVideo',
    FACE_RAW_INFO: 'faceRawInfo',
    FACE_SELECTED_INFO: 'faceSelectedInfo',
    HISTORY_LENGTH: 'historyLength',
    FACE_LOCATION: 'faceInfo',
};
export const getActionType = (str) => `update_${str}`;
// 设置当前页面
const updateCurPageAction = createAction(getActionType(BaseStateFieldKey.CURRENT_PAGE));
// 设置选中的素材
const updateSelectedMaterialAction = createAction(getActionType(BaseStateFieldKey.SELECTED_MATERIAL));
// 设置选中的素材列表
const updateMaterialConfigListAction = createAction(getActionType(BaseStateFieldKey.MATERIAL_CONFIG_LIST));
// 设置用户原图
const updateUserOriginImageAction = createAction(getActionType(BaseStateFieldKey.USER_ORIGIN_IMAGE));
// 设置用户裁切图
const updateUserCroppedImageAction = createAction(getActionType(BaseStateFieldKey.USER_CROPPED_IMAGE));
// 设置图片结果url
const updateImageResultUrlAction = createAction(getActionType(BaseStateFieldKey.IMAGE_RESULT_URL));
// 设置结果图url 列表
const updateImageResultUrlListAction = createAction(getActionType(BaseStateFieldKey.IMAGE_RESULT_URL_LIST));
// 设置视频结果url
const updateVideoResultUrlAction = createAction(getActionType(BaseStateFieldKey.VIDEO_RESULT_URL));
// 设置带二维码的视频结果url
const updateVideoResultUrlWidthQrCodeAction = createAction(getActionType(BaseStateFieldKey.VIDEO_RESULT_URL_WITH_QR_CODE));
// 设置视频结果封面图url
const updateVideoResultPosterUrlAction = createAction(getActionType(BaseStateFieldKey.VIDEO_RESULT_POSTER_URL));
// 设置视频下载schema
const updateVideoResultDownloadImageUrlAction = createAction(getActionType(BaseStateFieldKey.VIDEO_RESULT_DOWNLOAD_IMAGE_URL));
// 设置当前玩法类型
const updateIsVideoAction = createAction(getActionType(BaseStateFieldKey.IS_VIDEO));
// 设置人脸信息
const updateFaceRawInfo = createAction(getActionType(BaseStateFieldKey.FACE_RAW_INFO));
// 设置选择的人脸信息
const updateFaceSelectedInfo = createAction(getActionType(BaseStateFieldKey.FACE_SELECTED_INFO));
// 设置当前页面history层级
const updateHistoryLengthInfo = createAction(getActionType(BaseStateFieldKey.HISTORY_LENGTH));
// 设置人脸面部信息
const updateFaceLocationInfo = createAction(getActionType(BaseStateFieldKey.FACE_LOCATION));
export { updateCurPageAction, updateSelectedMaterialAction, updateUserOriginImageAction, updateUserCroppedImageAction, updateImageResultUrlAction, updateVideoResultUrlAction, updateVideoResultPosterUrlAction, updateVideoResultDownloadImageUrlAction, updateIsVideoAction, updateFaceRawInfo, updateFaceSelectedInfo, updateHistoryLengthInfo, updateMaterialConfigListAction, updateImageResultUrlListAction, updateFaceLocationInfo, updateVideoResultUrlWidthQrCodeAction, };
